export interface ForemanEmployee {
  foremanEmployeeID: string;
  employeeID: string | null;
  firstName: string;
  lastName: string;
  middleName: string;
  craft: string;
  companyID: string | null;
  cellPhone: string;
  last4SSN: string;
  shift: number | null;
  bActive: boolean | null;
}
